var map = {
	"./brand1.png": 34,
	"./brand2.png": 35,
	"./brand3.png": 36,
	"./fabrics.png": 37,
	"./hero.png": 18,
	"./impact.png": 38,
	"./impactBkg.png": 19,
	"./inovation.png": 20,
	"./leafLeft.png": 21,
	"./leafRight.png": 22,
	"./sewing.png": 39,
	"./speaking.png": 23,
	"./stock.png": 40,
	"./uniform.png": 41
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;